import React from 'react'

export const CategoryBanner = () => {
    return (
        <div><img src="images/category-banner.gif" alt="60% Off" /></div>
    )
}
